<template>
    <BasePanel
      icon="md-apps"
      title="常用板块"
    >
    <div class="flex-col" style="gap:5px">
      <div class="flex-wrap flex-between" style="width:100%;" v-if="appraisalEnable">
        <div class="flex-wrap flex-between hover-lighter m-light l-link-card"  :style="`margin-top:5px;background:linear-gradient(to bottom right,${appraisalStateColor},var(--bg1));height:130px;max-height:130px;`" @click="openAppraisal">
          <div style="background:#ffffff33;width:220px;height:300px;transform:rotate(30deg);position:absolute;right:-100px;top:-20px;"></div>
          <div style="background:#ffffff11;width:220px;height:300px;transform:rotate(30deg);position:absolute;right:-130px;top:-20px;"></div>
          <div class="flex-wrap" style="height:60px;">
            <div class="l-title">
                <h2 style="text-shadow:1px 1px 1px #333;">2025年度人员考核定级及评优工作</h2>
                <div class="l-sub" style="font-size:16px;color:#ddd;">{{ appraisal.dep ==-1?'无':appr_deps[appraisal.dep] }} | {{ appraisal.position == -1?'无':appr_positions[appraisal.position] }}</div>
            </div>
          </div>
          <div class="l-status" style="font-size:14px;color:yellow;">
            <div>
              {{appraisalState}}
            </div>
            <div class="l-sub" style="color:#ddd;">截止11月30日</div>
          </div>

        </div>

      </div>
      <div style="height:5px;background:var(--bg1);width:100%;" v-if="deps && deps.length > 0"></div>

      <div class="flex-wrap flex-between" style="width:100%;">
        <div class="flex-wrap flex-between hover-lighter m-light l-link-card" style="" :style="`background:var(--primary)`" @click="RouteTo(`http://www.gaozhuan.net:10000/acl/crossLogin.html?uid=${session.zzl_id}&phone=${session.phone}&platform=pmis&href=/v12/index.html`,true)">
          <div class="flex-wrap">
            <BaseIcon icon="nbgz" size="30" />
            <div class="l-title">
                项目管理平台
                <div class="l-sub">免登陆</div>
            </div>
          </div>
          <div class="l-status">
          </div>
        </div>

        <div class="flex-wrap flex-between hover-lighter m-light l-link-card" style="margin-left:5px" :style="`background:var(--warning)`" @click="RouteTo(`http://www.gaozhuan.net:10020/acl/crossLogin.html?uid=${session.zzl_id}&phone=${session.phone}&platform=jlis&href=/v2/index.html`,true)">
          <div class="flex-wrap">
            <BaseIcon icon="nbgz" size="30" />
            <div class="l-title">
                监理信息平台
                <div class="l-sub">免登陆</div>
            </div>
          </div>
          <div class="l-status">
          </div>
        </div>
      </div>
      <div class="flex-wrap flex-between" style="width:100%;flex-wrap:wrap;gap:5px">
        <template v-for="d in deps.slice(0,3)">
        <div class="flex-wrap flex-between hover-lighter m-light l-link-card" style="flex-shrink:0.5;width:calc(50% - 10px);" :style="`background:var(--bg1)`" :key="d.id" @click="openDep(d)">
          <div class="flex-wrap">
            <BaseIcon :icon="d.icon || 'organization'" size="30" />
            <div class="l-title">
              {{ d.name }}
                <div class="l-sub">部门入口</div>
            </div>
          </div>
          <div class="l-status">
          </div>
        </div>

      </template>
      </div>
      <div class="flex-wrap flex-between hover-lighter m-light l-link-card"  @click="RouteTo('/core/photowall')" style="background:var(--bg1)">
          <div class="flex-wrap">
            <BaseIcon icon="md-photos" size="30" />
            <div class="l-title">
              照片墙
                <div class="l-sub">找回曾经的记忆，欢迎的大家上传照片</div>
            </div>
          </div>
          <div class="l-status">
          </div>
        </div>

      </div>
      </BasePanel>

  </template>

<script>
import {mapGetters} from 'vuex';
import {uniqBy} from 'lodash';
export default {
  data() {
    return {
      appraisalState: '点击进入',
      appraisalEnable: false,
      appraisalStateColor: 'var(--primary)',
      appraisal: {},
      item: {
        id: 99,
        name: '青苗二期 《现场监理工作规定》解读1',
        teacher: '林密',
        date: '2023-04-21',
        address: '公司总部14楼多功能厅',
      },
      appr_deps: ['行政', '房建', '市政', '管理', '装修', '造价', 'BIM', '总师', '经营', '机电'],
      appr_positions: ['经理/总监(含副)', '经理助理/总代', '工程师级', '助理级/员级'],
    };
  },
  mounted() {
    this.$api.afterLogin(()=>{
      this.checkAppraisal();
      this.checkOTR();
    })
  
  },
  computed: {
    ...mapGetters('session', ['session']),
    deps() {
      const groups = this.session.groups || []
      const myGroups = groups.filter((v)=>v.type=='dep' && v.namespaced == 1);
      const authed_groups = this.session.authed_groups || [];
      return uniqBy([...myGroups, ...authed_groups], (a)=>a.id);
    },
  },
  methods: {
    checkOTR() {

    },
    checkAppraisal() {
      this.$api.get('/oa/appraisal_instances/self?appraisal_id=2025&simple=1').then((res)=>{
        const appraisal = res.data.data;
        if (appraisal.valid) {
          this.appraisalEnable = true;
          this.appraisal = appraisal;
        }
        if (appraisal && appraisal.id) {
          if (appraisal.state < 2) {
            this.appraisalStateColor = `var(--warning)`;
            this.appraisalState = '继续填写';
          } else {
            this.appraisalState = '已完成';
            this.appraisalStateColor = `var(--success)`;
          }
        } else {
          this.appraisalStateColor = `var(--error)`;
          this.appraisalState = '点击进入';
        }
      });
    },
    openAppraisal() {
      const base_url = `/core/appraisals/2025`;
      this.$store.commit('session/push', {
        path: base_url,
        base_url,
        icon: 'checkreport3',
        name: '2025年终考核',
      });
      this.RouteTo('/core/appraisals/2025');
    },
    openDep(d) {
      const base_url = `/core/groups/${d.id}`;
      this.$store.commit('session/push', {
        url: base_url+'/dashboard',
        base_url,
        icon: 'organization',
        name: d.name,
      });
      this.RouteTo(base_url+'/dashboard');
    },
    openApp() {
      const url = '/core/appraisals/otr';
      this.$store.commit('session/push', {
        url,
        base_url: url,
        icon: 'supervisor',
        name: '人才盘点',
      });
      this.RouteTo(url);
    },
    handleOpen() {
      const url = '/core/training/list';
      this.$store.commit('session/push', {
        url,
        base_url: url,
        icon: 'huiyi',
        name: '学习培训',
      });
      this.RouteTo(url);
    },
    handleOpenVideo() {
      const {id, name} = this.item;
      const type = 'video';
      const path = `/core/training/${id}/${type}`;
      this.$store.commit('session/push', {
        icon: 'logo-youtube',
        type: 'video',
        name,
        size: 24,
        path,
        base_url: `/core/training/${id}`,
      });
      this.RouteTo(path);
    },
  },
};
</script>

  <style lang="less">
  .l-activity{
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  .l-activity:hover{
    filter:brightness(1.1);

  }

  .l-activity:active{
    position: relative;
    bottom:-1px;
    right:-1px;
  }

  .l-link-card{
    max-height:70px;
    overflow:hidden;
    padding:10px;flex-grow:1;width:100%;font-size:16px;border-radius:3px;background:var(--primary);color:var(--hover-text);border:1px solid var(--border);box-shadow: 1px 1px 3px 1px #33333322;cursor:pointer;

    .l-title{
      margin-left:10px;font-size:14px;

    }

    .l-sub{
        font-size:12px;color:var(--hover-text);font-weight:normal;
      }

    .l-status{
      font-size:16px;text-align:center;filter:brightness(1);
    }


  }

  </style>
